// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuthHeaders } from "../../components/Token";
// import axios from "axios";
// import { API_BASE_URL } from "../../utils";
// import AlertModal from "../../reuseabelComponent/AlertModal";

// // Permission structure
// const permissionData = [
//   {
//     section: "Dashboard",
//     items: [
//       { name: "Dashboard", key: "dashboard" },
//       { name: "Profile", key: "profile" },
//       { name: "User", key: "user" },
//       { name: "Total Order", key: "totalOrder" },
//       { name: "Enquiry", key: "enquiry" },
//     ],
//   },
//   {
//     section: "Product",
//     items: [{ name: "Products", key: "products" }],
//   },
//   {
//     section: "Coupon",
//     items: [{ name: "Coupons", key: "coupons" }],
//   },
//   {
//     section: "Shipping",
//     items: [{ name: "Shipping", key: "shipping" }],
//   },
//   {
//     section: "Master",
//     items: [
//       { name: "Category", key: "category" },
//       { name: "Sub Category", key: "subCategory" },
//       { name: "Description", key: "description" },
//       { name: "Description Type", key: "descriptionType" },
//       { name: "Filter", key: "filter" },
//       { name: "Filter Type", key: "filterType" },
//       { name: "Offer Poster", key: "offerPoster" },
//       { name: "Blog", key: "blog" },
//     ],
//   },
// ];

// // Initial state builder
// const initPermissions = permissionData.reduce((acc, section) => {
//   const sectionKey = section.section.toLowerCase();
//   acc[sectionKey] = {};
//   section.items.forEach(({ key }) => {
//     acc[sectionKey][key] = {
//       create: false,
//       read: false,
//       edit: false,
//       delete: false,
//     };
//   });
//   return acc;
// }, {});

// export default function RedesignedPermissionsForm(data) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();
//   const [snackbar, setSnackbar] = useState(false);
//   const [snackbarVarient, setSnackbarVarient] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState(null);
//   const [permissions, setPermissions] = useState(
//     id ? initPermissions : data?.data?.permissions || initPermissions
//   );
//   console.log(data, " data?.permissions");
//   const accesstoken = localStorage.getItem("adminId");
//   useEffect(() => {
//     setPermissions(
//       id ? permissions : data?.data?.permissions || initPermissions
//     );
//   }, [data]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/vendor/${id}`, {
//           headers,
//         });
//         console.log(response, "response");
//         setPermissions(response.data.vendor.permissions);
//       } catch (error) {
//         console.error("Error fetching vendor data", error);
//       } finally {
//         // setLoading(false);
//       }
//     };
//     fetchData();
//   }, [id]);
//   const toggle = (sectionKey, itemKey, action) => {
//     setPermissions((prev) => ({
//       ...prev,
//       [sectionKey]: {
//         ...prev[sectionKey],
//         [itemKey]: {
//           ...prev[sectionKey][itemKey],
//           [action]: !prev[sectionKey][itemKey][action],
//         },
//       },
//     }));
//   };

//   const handleSave = () => {
//     const payload = { permissions };

//     const headers = {
//       Authorization: `Bearer ${accesstoken}`,
//       "Content-Type": "application/json",
//     };

//     axios
//       .patch(`${API_BASE_URL}/vendor/${id}/permissions`, payload, {
//         headers,
//       })
//       .then((response) => {
//         console.log("Response:>>>>>>>>>>>>", response);
//         if (response.data.success) {
//           setSnackbarVarient("success");
//           setSnackbarMessage(response.data.message);
//           setSnackbar(true);
//           navigate("/vendor-request");
//         } else {
//           setSnackbar(true);
//           setSnackbarVarient("error");
//           setSnackbarMessage(response.data.message);
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving permissions:", error);
//         alert("Failed to save permissions.");
//       });
//   };

//   const handleCancel = () => {
//     navigate("/vendor-request");
//   };

//   return (
//     <div className="container my-4">
//       <h3 className="mb-4 text-primary fw-bold">Permissions Management</h3>

//       <div className="table-responsive">
//         <table className="table align-middle text-center">
//           <thead className="table-light">
//             <tr>
//               <th className="text-start">Module</th>
//               <th>Create</th>
//               <th>Read</th>
//               <th>Edit</th>
//               <th>Delete</th>
//             </tr>
//           </thead>
//           <tbody>
//             {permissionData.map(({ section, items }) => {
//               const sectionKey = section.toLowerCase();
//               return (
//                 <React.Fragment key={section}>
//                   <tr className="table-secondary">
//                     <td colSpan="5" className="text-start fw-semibold">
//                       {section}
//                     </td>
//                   </tr>
//                   {items.map(({ name, key }) => (
//                     <tr key={key}>
//                       <td className="text-start">{name}</td>
//                       {["create", "read", "edit", "delete"].map((action) => {
//                         // const isAlwaysRead = action === "read";
//                         // const isDisabled =
//                         //   ["filter", "filterType", "offerPoster", "blog"].includes(key)

//                         const isDisabled = ["filter", "filterType", "offerPoster", "blog"].includes(key);
//                         const isAlwaysRead = action === "read" && !isDisabled;
//                         // const isDisabled = isReadAlwaysTrue || isRestrictedKey;

//                         return (

//                           <td key={action}>
//                             <div className="form-check form-switch d-flex justify-content-center">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 checked={
//                                   isAlwaysRead
//                                     ? true
//                                     : permissions[sectionKey]?.[key]?.[action] || false
//                                 }
//                                 disabled={isDisabled}
//                                 onChange={() => toggle(sectionKey, key, action)}
//                               />
//                             </div>
//                           </td>
//                         )
//                       })}
//                     </tr>
//                   ))}
//                 </React.Fragment>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//       <div className="d-flex justify-content-end gap-2 mt-3">
//         <button className="btn btn-secondary" onClick={handleCancel}>
//           Cancel
//         </button>
//         <button className="btn btn-primary" onClick={handleSave}>
//           Save
//         </button>
//       </div>

//       <AlertModal
//         show={snackbar}
//         onHide={() => setSnackbar(false)}
//         title={snackbarVarient}
//         message={snackbarMessage}
//         variant={snackbarVarient}
//         showConfirmButton={false} // Auto-closes when clicking outside
//       />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthHeaders } from "../../components/Token";
import axios from "axios";
import { API_BASE_URL } from "../../utils";
import AlertModal from "../../reuseabelComponent/AlertModal";

// Permission structure
const permissionData = [
  {
    section: "Dashboard",
    items: [
      { name: "Dashboard", key: "dashboard" },
      { name: "Profile", key: "profile" },
      // { name: "User", key: "user" },
      // { name: "Total Order", key: "totalOrder" },
      // { name: "Enquiry", key: "enquiry" },
    ],
  },
  {
    section: "Product",
    items: [{ name: "Products", key: "products" }],
  },
  // {
  //   section: "Coupon",
  //   items: [{ name: "Coupons", key: "coupons" }],
  // },
  // {
  //   section: "Shipping",
  //   items: [{ name: "Shipping", key: "shipping" }],
  // },
  {
    section: "Master",
    items: [
      { name: "Category", key: "category" },
      { name: "Sub Category", key: "subCategory" },
      { name: "Description", key: "description" },
      { name: "Description Type", key: "descriptionType" },
      // { name: "Filter", key: "filter" },
      // { name: "Filter Type", key: "filterType" },
      // { name: "Offer Poster", key: "offerPoster" },
      // { name: "Blog", key: "blog" },
    ],
  },
];

// Initial permissions with read:true by default (unless restricted)
const initPermissions = permissionData.reduce((acc, section) => {
  const sectionKey = section.section.toLowerCase();
  acc[sectionKey] = {};
  section.items.forEach(({ key }) => {
    const isRestricted = ["filter", "filterType", "offerPoster", "blog"].includes(key);
    acc[sectionKey][key] = {
      create: false,
      read: !isRestricted, // Default read to true unless restricted
      edit: false,
      delete: false,
    };
  });
  return acc;
}, {});

export default function RedesignedPermissionsForm(data) {
  const { id } = useParams();
  const navigate = useNavigate();
  const headers = useAuthHeaders();
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarVarient, setSnackbarVarient] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(null);
  const accesstoken = localStorage.getItem("adminId");

  const [permissions, setPermissions] = useState(
    id ? initPermissions : data?.data?.permissions || initPermissions
  );

  useEffect(() => {
    if (!id) {
      setPermissions(data?.data?.permissions || initPermissions);
    }
  }, [data, id]);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/vendor/${id}`, {
            headers,
          });
          setPermissions(response.data.vendor.permissions);
        } catch (error) {
          console.error("Error fetching vendor data", error);
        }
      };
      fetchData();
    }
  }, [id]);

  const toggle = (sectionKey, itemKey, action) => {
    setPermissions((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [itemKey]: {
          ...prev[sectionKey][itemKey],
          [action]: !prev[sectionKey][itemKey][action],
        },
      },
    }));
  };

  const handleSave = () => {
    const payload = { permissions };

    const headers = {
      Authorization: `Bearer ${accesstoken}`,
      "Content-Type": "application/json",
    };

    axios
      .patch(`${API_BASE_URL}/vendor/${id}/permissions`, payload, {
        headers,
      })
      .then((response) => {
        if (response.data.success) {
          setSnackbarVarient("success");
          setSnackbarMessage(response.data.message);
          setSnackbar(true);
          navigate("/approve-vendor");
        } else {
          setSnackbar(true);
          setSnackbarVarient("error");
          setSnackbarMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error saving permissions:", error);
        alert("Failed to save permissions.");
      });
  };

  const handleCancel = () => {
    navigate("/approve-vendor");
  };

  return (
    <div className="container my-4">
      <h3 className="mb-4 text-primary fw-bold">Permissions Management</h3>

      <div className="table-responsive">
        <table className="table align-middle text-center">
          <thead className="table-light">
            <tr>
              <th className="text-start">Module</th>
              <th>Create</th>
              <th>Read</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {permissionData.map(({ section, items }) => {
              const sectionKey = section.toLowerCase();
              return (
                <React.Fragment key={section}>
                  <tr className="table-secondary">
                    <td colSpan="5" className="text-start fw-semibold">
                      {section}
                    </td>
                  </tr>
                  {items.map(({ name, key }) => (
                    <tr key={key}>
                      <td className="text-start">{name}</td>
                      {["create", "read", "edit", "delete"].map((action) => {
                        const isReadRestricted =
                          action === "read" &&
                          ["filter", "filterType", "offerPoster", "blog"].includes(key);

                        return (
                          <td key={action}>
                            <div className="form-check form-switch d-flex justify-content-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  permissions[sectionKey]?.[key]?.[action] || false
                                }
                                disabled={isReadRestricted}
                                onChange={() => toggle(sectionKey, key, action)}
                              />
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <button className="btn btn-secondary" onClick={handleCancel}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={handleSave}>
          Save
        </button>
      </div>

      <AlertModal
        show={snackbar}
        onHide={() => setSnackbar(false)}
        title={snackbarVarient}
        message={snackbarMessage}
        variant={snackbarVarient}
        showConfirmButton={false}
      />
    </div>
  );
}
